import { Component, OnInit } from '@angular/core';
import { MapService } from '../_services/map.service';

@Component({
  selector: 'app-log-list',
  templateUrl: './log-list.component.html',
  styleUrls: ['./log-list.component.css']
})
export class LogListComponent implements OnInit {
  spiskovi = [];
  greske = [];
  message = 'Učitavanje...';
  constructor(private mapService: MapService) { }

  ngOnInit() {
    this.loadLogs();
  }

  loadLogs() {
    if (localStorage.selectedVehicleImei != null) {
      this.mapService.getLogsSpiskovi(localStorage.selectedVehicleImei, 100).subscribe(data => {
        this.spiskovi = data;
        this.mapService.getLogsGreske(localStorage.selectedVehicleImei, 100).subscribe(data2 => {
          this.greske = data2;
          this.message = 'Nema informacija za odabrano vozilo!';
        });
      });
    }

  }
}
